<template>
  <div>
    <!-- <div class="article">
      <div class="p1">公告</div>
      <ul
        :style="{
          animation: `infinite_scroll${data.articleList.length} ${
            data.articleList.length * 10
          }s linear infinite`,
        }"
      >
        <li
          v-for="(item, index) in [...data.articleList, ...data.articleList]"
          :key="index"
          @click="articleHandle(item)"
        >
          <span>
            {{ moment.unix(item.create_time).format('MM-DD HH:mm') }}
          </span>
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div> -->
    <div class="userinfo">
      <div class="l">
        <div class="item">
          <img src="@/assets/img/avatar.png" width="84" />
          <!-- <div class="info">
            <div class="t1">{{ userInfo && userInfo.cname }}</div>
            <div class="t2">
              <img src="@/assets/img/user_icon1.png" />
              {{ userInfo && userInfo.cname }}
            </div>
          </div> -->

          <el-popover popper-class="pd0" trigger="click" :width="226">
            <template #reference>
              <div class="info">
                <div>
                  <el-space class="t1">
                    <div v-if="countReactive.active.id">
                      {{ countReactive.active.nickname }}
                    </div>
                    <div v-else>{{ userInfo.cname }}</div>
                    <img
                      class="select_arrow"
                      src="@/assets/img/select_arrow.png"
                    />
                  </el-space>
                </div>
                <div class="t2">
                  已绑定
                  <el-icon v-if="newdata.loading" class="is-loading">
                    <Loading />
                  </el-icon>
                  <template v-else>{{ newdata.count_list.count1 }}</template>
                  个账号
                </div>
              </div>
            </template>
            <template #default>
              <div
                class="select_item"
                :class="{ active: !countReactive.active.id }"
                @click="countReactive.active = {}"
              >
                <img src="@/assets/img/avatar.png" />
                <div class="ellipsis">全部账号</div>
              </div>
              <div
                class="select_item"
                :class="{ active: countReactive.active.id === item.id }"
                v-for="item in newdata.auth_list"
                :key="item.id"
                @click="countReactive.active = item"
              >
                <img :src="item.avatar" />
                <div class="ellipsis">{{ item.nickname }}</div>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
      <div class="r">
        <div class="item">
          <img src="@/assets/img/user_icon2.png" />
          <div class="info">
            <!-- <div class="t1">{{ data.countList[6].count }}</div> -->
            <div class="t1">{{ countReactive.data.digg_count }}</div>
            <div class="t2">获赞</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/img/user_icon3.png" />
          <div class="info">
            <!-- <div class="t1">{{ data.countList[7].count }}</div> -->
            <div class="t1">{{ countReactive.data.fans_count }}</div>
            <div class="t2">粉丝</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/img/user_icon4.png" />
          <div class="info">
            <!-- <div class="t1">{{ data.countList[8].count }}</div> -->
            <div class="t1">{{ countReactive.data.video_count }}</div>
            <div class="t2">视频</div>
          </div>
        </div>
      </div>
    </div>
    <el-row class="data_list" :class="{ mobile: isMobileObj.any }" :gutter="20">
      <el-col :span="isMobileObj.any ? 12 : 4">
        <el-space class="item" direction="vertical" alignment="flex-start" fill>
          <div class="text">
            <img :src="require(`@/assets/img/index_icon1.svg`)" />
            日常视频总播放量（次）
          </div>
          <div class="number">
            <!-- {{ data.countList[0].count }} -->
            {{ countReactive.data.play_count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
      <el-col :span="isMobileObj.any ? 12 : 4">
        <el-space class="item" direction="vertical" alignment="flex-start" fill>
          <div class="text">
            <img :src="require(`@/assets/img/index_icon2.svg`)" />
            广告视频总展现量（次）
          </div>
          <div class="number">
            {{ data.countList[1].count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
      <el-col :span="isMobileObj.any ? 12 : 4">
        <el-space
          class="item bg2"
          direction="vertical"
          alignment="flex-start"
          fill
        >
          <div class="text">
            <img :src="require(`@/assets/img/index_icon3.svg`)" />
            用户行为量（次）
          </div>
          <div class="number">
            {{ data.countList[2].count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
      <el-col :span="isMobileObj.any ? 12 : 4">
        <el-space
          class="item bg3"
          direction="vertical"
          alignment="flex-start"
          fill
        >
          <div class="text">
            <img :src="require(`@/assets/img/index_icon4.svg`)" />
            私信跟进量（次）
          </div>
          <div class="number">
            <!-- {{ data.countList[3].count }} -->
            {{ countReactive.data.user_intention_dialogue_count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
      <el-col :span="isMobileObj.any ? 12 : 4">
        <el-space
          class="item bg2"
          direction="vertical"
          alignment="flex-start"
          fill
        >
          <div class="text">
            <img :src="require(`@/assets/img/index_icon1.svg`)" />
            线索数量（个）
          </div>
          <div class="number">
            {{ data.countList[4].count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
      <el-col :span="isMobileObj.any ? 12 : 4">
        <el-space
          class="item bg4"
          direction="vertical"
          alignment="flex-start"
          fill
        >
          <div class="text">
            <img :src="require(`@/assets/img/index_icon3.svg`)" />
            评论数量（次）
          </div>
          <div class="number">
            <!-- {{ data.countList[5].count }} -->
            {{ countReactive.data.comment_count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="20" class="tbox">
      <el-col
        :span="24"
        :style="{ marginBottom: isMobileObj.any ? '20px' : 0 }"
      >
        <div class="box pt15 index_link">
          <div class="title mb0">常用功能</div>
          <div class="list">
            <router-link to="/site" class="item">
              <img src="@/assets/img/index_link1.png" />
              <div>企业号配置</div>
            </router-link>
            <router-link to="/reply" class="item">
              <img src="@/assets/img/index_link2.png" />
              <div>智能客服</div>
            </router-link>
            <router-link to="/video_pro_create" class="item">
              <img src="@/assets/img/index_link3.png" />
              <div>视频剪辑</div>
            </router-link>
            <router-link to="/video_pro_release_smart" class="item">
              <img src="@/assets/img/index_link4.png" />
              <div>视频发布</div>
            </router-link>
            <router-link to="/leads_user_list" class="item">
              <img src="@/assets/img/index_link5.png" />
              <div>客户线索</div>
            </router-link>
            <router-link to="/business_ad" class="item">
              <img src="@/assets/img/index_link6.png" />
              <div>企业号广告</div>
            </router-link>
            <router-link to="/task_crm_index" class="item">
              <img src="@/assets/img/index_link7.png" />
              <div>搜索位广告</div>
            </router-link>
          </div>
        </div>
      </el-col>
    </el-row> -->

    <div class="grid_box">
      <div class="yyjy box">
        <div class="mb20">运营建议</div>
        <el-steps :active="6" direction="vertical" align-center>
          <el-step>
            <template #title>
              <div class="item">
                <div class="info">
                  <div class="l">
                    <img src="@/assets/img/index_count_icon1.png" />
                  </div>
                  <div class="c">
                    <div class="t1">认证两个蓝v账号，并绑定</div>
                    <div class="t2">
                      进入
                      <a href="https://renzheng.douyin.com/" target="_blank">
                        立即认证
                      </a>
                      ，点击立即认证按照要求进行填写
                    </div>
                  </div>
                </div>
                <div class="r">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="item">
                <div class="info">
                  <div class="l">
                    <img src="@/assets/img/index_count_icon2.png" />
                  </div>
                  <div class="c">
                    <div class="t1">装修蓝v账号</div>
                    <div class="t2">头像、顶图、介绍，电话、地址、商家主页</div>
                  </div>
                </div>
                <div class="r">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="item">
                <div class="info">
                  <div class="l">
                    <img src="@/assets/img/index_count_icon3.png" />
                  </div>
                  <div class="c">
                    <div class="t1">账户SEO设置</div>
                    <div class="t2">
                      将产品关键词进行布局，可以使用工具箱里面的拓词工具
                    </div>
                  </div>
                </div>
                <div class="r">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="item">
                <div class="info">
                  <div class="l">
                    <img src="@/assets/img/index_count_icon4.png" />
                  </div>
                  <div class="c">
                    <div class="t1">制作视频素材</div>
                    <div class="t2">
                      创作统一封面视频素材，建议制作100个视频以上
                    </div>
                  </div>
                </div>
                <div class="r">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="item">
                <div class="info">
                  <div class="l">
                    <img src="@/assets/img/index_count_icon5.png" />
                  </div>
                  <div class="c">
                    <div class="t1">
                      设置智能发布、每个账户每天建议发布两个视频
                    </div>
                    <div class="t2">
                      每个账户每天发布2个视频，保持更新不间断
                    </div>
                  </div>
                </div>
                <div class="r">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </template>
          </el-step>
          <el-step>
            <template #title>
              <div class="item">
                <div class="info">
                  <div class="l">
                    <img src="@/assets/img/index_count_icon6.png" />
                  </div>
                  <div class="c">
                    <div class="t1">绑定微信，接收意向客户提醒</div>
                    <div class="t2">绑定微信，有客户提醒不错过</div>
                  </div>
                </div>
                <div class="r">
                  <el-icon><Check /></el-icon>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
      <div class="tools box">
        <div class="mb20">工具箱</div>
        <div class="list">
          <!-- <div class="item" @click="reactivePopupTool1.visible = true">
            <img src="@/assets/img/index_icon7.png" />
            <div>发布客户端</div>
          </div> -->
          <a
            class="item"
            href="https://ptak5977a2.feishu.cn/docx/Uk8KdAYv0ofOpbxPXdHcK6oknpf?from=from_copylink"
            target="_blank"
          >
            <img src="@/assets/img/index_icon7.png" />
            <div>发布客户端</div>
          </a>
          <a class="item" href="/upload/chrome-xtensions.zip" target="_blank">
            <img src="@/assets/img/index_icon8.png" />
            <div>授权插件</div>
          </a>
          <div class="item" @click="reactivePopupTool3.visible = true">
            <img src="@/assets/img/index_icon9.png" />
            <div>拓词工具</div>
          </div>
          <div class="item" @click="reactivePopupTool4.visible = true">
            <img src="@/assets/img/index_icon10.png" />
            <div>视频提取</div>
          </div>
          <div class="item" @click="reactivePopupTool5.visible = true">
            <img src="@/assets/img/index_icon11.png" />
            <div>BGM提取</div>
          </div>
          <div class="item" @click="reactivePopupTool6.visible = true">
            <img src="@/assets/img/index_icon12.png" />
            <div>chatGPT</div>
          </div>
          <a
            class="item"
            :href="data.case_url"
            target="_blank"
            v-show="data.case_url"
          >
            <img src="@/assets/img/index_icon13.png" />
            <div>综合报表</div>
          </a>
        </div>
      </div>
    </div>

    <el-row :gutter="20" class="tbox2">
      <el-col
        :span="isMobileObj.any ? 24 : 12"
        :style="{ marginBottom: isMobileObj.any ? '20px' : 0 }"
      >
        <div class="box pt15">
          <div class="title mb20">评论数据</div>
          <el-table
            ref="table"
            :data="data.tableData3"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column type="index" label="序号" width="80" />
            <el-table-column prop="content" label="评论内容" />
            <el-table-column
              prop="create_time"
              label="评论时间"
              min-width="88"
            />
          </el-table>
          <div class="scroll_box">
            <el-table
              ref="table"
              :data="data.tableData3"
              highlight-current-row
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :show-header="false"
              :style="{
                animationDuration: `${data.tableData3.length}s`,
              }"
              v-if="data.tableData3.length"
            >
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column prop="content" label="评论内容" />
              <el-table-column
                prop="create_time"
                label="评论时间"
                min-width="88"
              />
            </el-table>
            <div class="table_empty" v-else>
              <img src="@/assets/img/index_table1.png" />
              <div>暂无评论，您可以通过发布视频增加评论</div>
              <router-link to="/video_pro_release_smart" class="btn">
                发布视频
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col
        :span="isMobileObj.any ? 24 : 12"
        v-if="data.tableData4.length > data.tableData2.length"
      >
        <div class="box pt15">
          <div class="title mb20">巨量线索</div>
          <el-table
            ref="table"
            :data="data.tableData4"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column type="index" label="序号" width="80" />
            <el-table-column prop="name" label="姓名" />
            <el-table-column prop="telephone" label="联系方式" />
            <el-table-column
              prop="create_time_detailVal"
              label="线索时间"
              min-width="88"
            />
          </el-table>
          <div class="scroll_box">
            <el-table
              ref="table"
              :data="data.tableData4"
              highlight-current-row
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :show-header="false"
              :style="{
                animationDuration: `${data.tableData4.length}s`,
              }"
              v-if="data.tableData4.length"
            >
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column prop="name" label="姓名" />
              <el-table-column prop="telephone" label="联系方式" />
              <el-table-column
                prop="create_time_detailVal"
                label="线索时间"
                min-width="88"
              />
            </el-table>
            <div class="table_empty" v-else>
              <img src="@/assets/img/index_table2.png" />
              <div>暂无巨量线索，您可以通过发布视频增加流量</div>
              <router-link to="/video_pro_release_smart" class="btn">
                发布视频
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="isMobileObj.any ? 24 : 12" v-else>
        <div class="box pt15">
          <div class="title mb20">互动线索</div>
          <el-table
            ref="table"
            :data="data.tableData2"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column type="index" label="序号" width="80" />
            <el-table-column prop="nickname" label="昵称" />
            <el-table-column prop="telephone" label="联系方式" />
            <el-table-column
              prop="update_time"
              label="线索时间"
              min-width="88"
            />
          </el-table>
          <div class="scroll_box">
            <el-table
              ref="table"
              :data="data.tableData2"
              highlight-current-row
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :show-header="false"
              :style="{
                animationDuration: `${data.tableData2.length}s`,
              }"
              v-if="data.tableData2.length"
            >
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column prop="nickname" label="昵称" />
              <el-table-column prop="telephone" label="联系方式" />
              <el-table-column
                prop="update_time"
                label="线索时间"
                min-width="88"
              />
            </el-table>
            <div class="table_empty" v-else>
              <img src="@/assets/img/index_table2.png" />
              <div>暂无互动线索，您可以通过发布视频增加流量</div>
              <router-link to="/video_pro_release_smart" class="btn">
                发布视频
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="tbox2">
      <el-col
        :span="isMobileObj.any ? 24 : 12"
        :style="{ marginBottom: isMobileObj.any ? '20px' : 0 }"
      >
        <div class="box pt15">
          <div class="title mb20">关键词排名</div>
          <el-table
            ref="table"
            :data="data.tableData1"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column type="index" label="序号" width="80" />
            <el-table-column prop="keyword" label="关键词" />
            <el-table-column prop="rank" label="排名">
              <template #default="{ row }">第{{ row.rank }}位</template>
            </el-table-column>
            <el-table-column
              prop="update_time"
              label="查询时间"
              min-width="88"
            />
          </el-table>
          <div class="scroll_box">
            <el-table
              ref="table"
              :data="data.tableData1"
              highlight-current-row
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :show-header="false"
              :style="{
                animationDuration: `${data.tableData1.length}s`,
              }"
              v-if="data.tableData1.length"
            >
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column prop="keyword" label="关键词" />
              <el-table-column prop="rank" label="排名">
                <template #default="{ row }">第{{ row.rank }}位</template>
              </el-table-column>
              <el-table-column
                prop="update_time"
                label="查询时间"
                min-width="88"
              />
            </el-table>
            <div class="table_empty" v-else>
              <img src="@/assets/img/index_table1.png" />
              <div>暂无关键词，您可以通过发布视频增加流量</div>
              <router-link to="/video_pro_release_smart" class="btn">
                发布视频
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="isMobileObj.any ? 24 : 12">
        <div class="box pt15">
          <div class="title mb20">数据统计</div>
          <ChartLine :chartData="data.chartDataLine" :height="439" />
        </div>
      </el-col>
    </el-row>

    <canvas ref="canvasRef" style="display: none"></canvas>
    <el-dialog
      class="article_dialog new_dialog"
      title="信息"
      v-model="articleReactive.visible"
      :width="isMobileObj.any ? '90%' : '50%'"
    >
      <div class="title">{{ articleReactive.data.title }}</div>
      <div class="time">
        {{
          moment.unix(articleReactive.data.create_time).format('MM-DD HH:mm')
        }}
      </div>
      <div class="content" v-html="articleReactive.data.content"></div>
    </el-dialog>
    <PopupTool1 v-model="reactivePopupTool1.visible" />
    <PopupTool3 v-model="reactivePopupTool3.visible" />
    <PopupTool4 v-model="reactivePopupTool4.visible" />
    <PopupTool5 v-model="reactivePopupTool5.visible" />
    <PopupTool6 v-model="reactivePopupTool6.visible" />
  </div>
</template>

<script setup>
import { reactive, ref, toRefs, computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'
import isMobile from 'ismobilejs'
import {
  index_data,
  rank,
  business_ad_bgb_consume,
  article,
  leads_user_list,
  enterprise_video_comment,
  task_crm,
  task_plcrm,
  new_index_count,
  new_index_data,
} from '@/utils/api'
import { Check } from '@element-plus/icons-vue'
import ChartLine from '@/components/ChartLine'
import PopupTool1 from '@/components/PopupTool1'
import PopupTool3 from '@/components/PopupTool3'
import PopupTool4 from '@/components/PopupTool4'
import PopupTool5 from '@/components/PopupTool5'
import PopupTool6 from '@/components/PopupTool6'
import { Loading } from '@element-plus/icons-vue'

const store = useStore()
const { state } = store
const { userInfo } = toRefs(state)

const isMobileObj = isMobile(window.navigator)

const data = reactive({
  countList: [
    { name: '日常视频总播放量', unit: '次', count: 0 },
    { name: '广告视频总展现量', unit: '次', count: 0 },
    { name: '用户行为量', unit: '次', count: 0 },
    { name: '私信跟进量', unit: '次', count: 0 },
    { name: '线索数量', unit: '个', count: 0 },
    { name: '评论数量', unit: '次', count: 0 },
    { name: '获赞', unit: '个', count: 0 },
    { name: '粉丝', unit: '个', count: 0 },
    { name: '视频', unit: '个', count: 0 },
  ],
  articleList: [],
  keyword_list: [
    { name: 'TOP10关键词', count: 0 },
    { name: 'TOP20关键词', count: 0 },
    { name: '八字以下关键词', count: 0 },
    { name: 'A+B & B+C关键词', count: 0 },
    { name: '词库关键词', count: 0 },
  ],
  keyword_time: '',
  chartDataDoughnut: {
    // labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
    // datasets: [
    //   {
    //     backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
    //     data: [40, 20, 80, 10],
    //   },
    // ],
  },
  chartDataLine: {
    // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    // datasets: [
    //   {
    //     label: 'Data One',
    //     backgroundColor: '#00D8FF',
    //     fill: true,
    //     tension: 0.4,
    //     data: [40, 39, 10, 40, 39, 80, 40],
    //   },
    //   {
    //     label: 'Data Two',
    //     backgroundColor: '#E46651',
    //     fill: true,
    //     tension: 0.4,
    //     data: [60, 55, 32, 10, 2, 12, 53],
    //   },
    // ],
  },
  tableData1: [],
  tableData2: [],
  tableData3: [],
  tableData4: [],
  video_count: 0,
})

index_data({
  params: {
    type: 'v2_2',
  },
}).then(({ data: res }) => {
  // res.data.count_list.forEach((v, i) => {
  //   let floor = Math.floor(i / 6)
  //   let modulo = i % 6
  //   data.countList[floor][modulo] = v
  // })

  data.countList = res.data.count_list

  data.chartDataDoughnut = {
    labels: ['自然流量', '商业流量'],
    datasets: [
      {
        backgroundColor: ['#0E2E5B'],
        borderWidth: 0,
        data: [1],
        weight: 2,
      },
      {
        backgroundColor: ['#016FED', '#EDA600'],
        data: res.data.percent_count,
        borderWidth: 0,
        weight: 10,
      },
    ],
  }
  Object.assign(data, res.data)
  // store.commit('indexData', res.data)
})

const canvasRef = ref()
article().then(({ data: res }) => {
  data.articleList = res.data
})

business_ad_bgb_consume({ page: 1, limit: 5 }).then(({ data: res }) => {
  let gradient1 = canvasRef.value
    .getContext('2d')
    .createLinearGradient(0, 0, 0, 450)
  let gradient2 = canvasRef.value
    .getContext('2d')
    .createLinearGradient(0, 0, 0, 450)

  gradient1.addColorStop(0, 'rgba(1, 111, 237, 0.2)')
  gradient1.addColorStop(1, 'rgba(1, 111, 237, 0)')
  gradient2.addColorStop(0, 'rgba(237,166,0, 0.2)')
  gradient2.addColorStop(1, 'rgba(237,166,0, 0)')

  res.data.datasets[0].backgroundColor = gradient1
  res.data.datasets[1].backgroundColor = gradient2

  // data.chartDataLine = res.data
  data.chartDataLine = {
    labels: res.data.labels,
    datasets: [
      {
        label: '点击',
        borderWidth: 3,
        borderColor: '#016FED',
        backgroundColor: gradient1,
        fill: true,
        tension: 0,
        data: res.data.datasets[0],
      },
      {
        label: '展现',
        borderWidth: 3,
        borderColor: '#EDA600',
        backgroundColor: gradient2,
        fill: true,
        tension: 0,
        data: res.data.datasets[1],
      },
    ],
  }
})

const articleReactive = reactive({
  visible: false,
  data: {},
})
const articleHandle = (item) => {
  articleReactive.visible = true
  articleReactive.data = item
}

const use_days = computed(() => {
  const diff = moment().diff(moment(userInfo.value.end_time))
  return Math.round(
    moment
      .duration(
        diff > 0
          ? moment(userInfo.value.end_time).diff(
              moment(userInfo.value.start_time)
            )
          : moment().diff(moment(userInfo.value.start_time))
      )
      .asDays()
  )
})

const pointer_rotate = ref(225)
watchEffect(
  () => {
    pointer_rotate.value =
      225 + ((use_days.value > 360 ? 360 : use_days.value) / 10) * 7.5
  },
  {
    flush: 'post',
  }
)

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  rank(
    {
      page: 1,
      limit: 100,
      type: 1,
    },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    data.tableData1 = [...res.data, ...res.data]
  })
  onInvalidate(() => {
    controller.abort()
  })
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  leads_user_list(
    {
      page: 1,
      limit: 100,
    },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    data.tableData2 = [...res.data, ...res.data]
  })
  onInvalidate(() => {
    controller.abort()
  })
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  enterprise_video_comment(
    {
      page: 1,
      limit: 100,
      type: '',
    },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    if (res.data.length) {
      data.tableData3 = [...res.data, ...res.data]
    } else {
      task_plcrm(
        {
          page: 1,
          limit: 100,
          type: 'all',
        },
        { signal: controller.signal }
      ).then(({ data: res }) => {
        data.tableData3 = [...res.data, ...res.data]
      })
    }
  })
  onInvalidate(() => {
    controller.abort()
  })
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  task_crm(
    {
      page: 1,
      limit: 100,
      type: 'all',
    },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    data.tableData4 = [...res.data, ...res.data]
  })
  onInvalidate(() => {
    controller.abort()
  })
})

const reactivePopupTool1 = reactive({
  visible: false,
})

const reactivePopupTool3 = reactive({
  visible: false,
})

const reactivePopupTool4 = reactive({
  visible: false,
})

const reactivePopupTool5 = reactive({
  visible: false,
})

const reactivePopupTool6 = reactive({
  visible: false,
})

const countReactive = reactive({
  active: {},
  data: {
    fans_count: 0,
    video_count: 0,
    play_count: 0,
    digg_count: 0,
    comment_count: 0,
    user_intention_dialogue_count: 0,
  },
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  new_index_count(
    { aid: countReactive.active.id },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    countReactive.data = res.data
  })
  onInvalidate(() => {
    controller.abort()
  })
})

const newdata = reactive({
  // countList: [
  //   [
  //     {
  //       name: '总曝光量',
  //       unit: '次',
  //       count: 0,
  //       info: '总曝光量等于自然流量+商业流量的总和',
  //     },
  //     {
  //       name: '自然流量',
  //       unit: '次',
  //       count: 0,
  //       info: '自然流量指发布到抖音，快手，视频号，小红书，哔哩哔哩，头条，西瓜等平台的流量总和',
  //     },
  //     {
  //       name: '商业流量',
  //       unit: '次',
  //       count: 0,
  //       info: '商业流量指通过信息流广告或搜索广告投放的流量总和',
  //     },
  //     {
  //       name: '用户行为',
  //       unit: '次',
  //       count: 0,
  //       info: '用户行为指和企业号发生过私信，主页留资，转化页留资，评论，点赞（包括所有平台）等行为',
  //     },
  //     {
  //       name: '私信跟进',
  //       unit: '次',
  //       count: 0,
  //       info: '私信跟进指给用户回复信息的次数',
  //     },
  //     {
  //       name: '意向用户',
  //       unit: '个',
  //       count: 0,
  //       info: '意向用户指和企业号发生过私信，主页留资，转化页留资等行为的用户数',
  //     },
  //   ],
  //   [
  //     {
  //       name: '获赞次数',
  //       unit: '个',
  //       count: 0,
  //       info: '获赞次数指用户视频累计获赞次数总和',
  //     },
  //     {
  //       name: '累计粉丝',
  //       unit: '个',
  //       count: 0,
  //       info: '累计粉丝指账号累计粉丝的数量总和',
  //     },
  //     {
  //       name: '互动线索',
  //       unit: '个',
  //       count: 0,
  //       info: '互动线索指通过和企业号发生过私信，主页留资，转化页留资留下手机号的数量总和',
  //     },
  //     {
  //       name: '私信数量',
  //       unit: '个',
  //       count: 0,
  //       info: '私信数量指用户通过私信给您发送消息的数量总和',
  //     },
  //     {
  //       name: '评论数量',
  //       unit: '个',
  //       count: 0,
  //       info: '评论数量指用户给您视频评论的数量总和',
  //     },
  //     {
  //       name: '大数据线索',
  //       unit: '个',
  //       count: 0,
  //       info: '大数据线索指通过海量数据筛选而来的线索',
  //     },
  //   ],
  // ],
  articleList: [],
  keyword_list: [
    { name: 'TOP10关键词', count: 0 },
    { name: 'TOP20关键词', count: 0 },
    { name: '八字以下关键词', count: 0 },
    { name: 'A+B & B+C关键词', count: 0 },
    { name: '词库关键词', count: 0 },
  ],
  keyword_time: '',
  chartDataDoughnut: {
    // labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
    // datasets: [
    //   {
    //     backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
    //     data: [40, 20, 80, 10],
    //   },
    // ],
  },
  chartDataLine: {
    // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    // datasets: [
    //   {
    //     label: 'Data One',
    //     backgroundColor: '#00D8FF',
    //     fill: true,
    //     tension: 0.4,
    //     data: [40, 39, 10, 40, 39, 80, 40],
    //   },
    //   {
    //     label: 'Data Two',
    //     backgroundColor: '#E46651',
    //     fill: true,
    //     tension: 0.4,
    //     data: [60, 55, 32, 10, 2, 12, 53],
    //   },
    // ],
  },
  case_url: '',
  auth_list: [],
  count_list: {
    count1: 0,
    count2: 0,
    count3: 0,
  },
  loading: true,
})

new_index_data().then(({ data: res }) => {
  // res.data.count_list.forEach((v, i) => {
  //   let floor = Math.floor(i / 6)
  //   let modulo = i % 6
  //   data.countList[floor][modulo] = Object.assign(
  //     data.countList[floor][modulo],
  //     v
  //   )
  // })

  newdata.chartDataDoughnut = {
    labels: ['自然流量', '商业流量'],
    datasets: [
      {
        backgroundColor: ['#0E2E5B'],
        borderWidth: 0,
        data: [1],
        weight: 2,
      },
      {
        backgroundColor: ['#016FED', '#EDA600'],
        data: res.data.percent_count,
        borderWidth: 0,
        weight: 10,
      },
    ],
  }
  Object.assign(newdata, res.data)
  newdata.loading = false
  // store.commit('indexData', res.data)
})
</script>

<style scoped lang="scss">
@import '@/assets/css/color.scss';

.el-row {
  margin-bottom: 20px;
}
.tbox {
  .box {
    height: 303px;
  }
}
.rank_list {
  height: 400px;
  overflow: hidden;
  position: relative;
  .scroll_box {
    animation: infinite_scroll 10s linear infinite;
  }
  .item {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 2;
  }
  .c2 {
    color: #bbb;
  }
  .time {
    text-align: right;
  }
}
.article {
  margin-bottom: 20px;
  font-size: 16px;
  height: 24px;
  line-height: 24px;
  overflow: hidden;
  .p1 {
    color: #eda600;
    margin-right: 20px;
    float: left;
  }
  ul {
    overflow: hidden;
    animation: infinite_scroll2 10s linear infinite;
  }
  li {
    display: flex;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
    &:hover,
    &:active {
      color: #5fa5fa;
    }
    span {
      margin-right: 17px;
      opacity: 0.6;
    }
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.doughnut_box {
  display: flex;
  align-items: center;
  width: 80%;
  margin-left: 20%;
  canvas::after {
    content: '';
    width: 229px;
    height: 229px;
    border-radius: 50%;
    background-color: #0e2e5b;
    position: absolute;
    z-index: -1;
  }
}
.keyword_list {
  font-size: 16px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #24385e;
    height: 38px;
    &:last-child {
      border-bottom: 0;
    }
    p {
      color: #cadbee;
    }
  }
}

.package_box {
  height: calc(100% - 61px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  ul {
    padding-top: 25px;
    padding-left: 20px;
  }
  li {
    display: flex;
    align-items: center;
    font-size: 18px;
    margin-bottom: 25px;
    white-space: nowrap;
    span {
      color: #cadbee;
      margin-right: 13px;
    }
  }
  .dashboard {
    flex: none;
    width: 208px;
    height: 208px;
    border-radius: 50%;
    background-color: #0b1830;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .ring {
      flex: none;
      width: 188px;
      height: 188px;
      border-radius: 50%;
      border-width: 30px;
      border-style: solid;
      border-color: #0cb876 #ed8e00 #0b1830 #016fed;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .scale {
        width: 1px;
        height: 94px;
        border-top: 7px solid #fff;
        position: absolute;
        top: -30px;
        transform: rotate(225deg);
        transform-origin: bottom center;
        z-index: 1;
      }
      .pointer {
        width: 10px;
        height: 94px;
        background: url(@/assets/img/dashboard_pointer.png) no-repeat bottom
          center;
        position: absolute;
        margin-left: -5px;
        top: -30px;
        transform-origin: bottom center;
        transform: rotate(225deg);
        transition: transform 1s;
        z-index: 2;
      }
    }
    .info {
      position: absolute;
      top: 115px;
      font-size: 25px;
      font-weight: bold;
      z-index: 3;
      span {
        color: #cadbee;
      }
    }
  }
}
.userinfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 15px;
  /* border-top: 1px solid #7e899f; */
  .item {
    display: flex;
    align-items: center;
    > img {
      margin-right: 15px;
    }
    .t1 {
      font-weight: bold;
      margin-bottom: 10px;
      font-size: 20px;
    }
    .t2 {
      font-size: 16px;
    }
  }
  .l .item {
    > img {
      margin-right: 25px;
    }
    .t2 {
      background: #2e5bf6;
      border-radius: 4px;
      line-height: 23px;
      display: inline-block;
      padding: 0 7px;
    }
  }
  .r {
    display: flex;
    align-items: center;
    .item {
      margin-left: 32px;
      .t1 {
        font-size: 24px;
      }
    }
  }
}
.data_list {
  .el-col {
    .item {
      background: #1b315e url(@/assets/img/data_list_bg1.png) no-repeat right
        bottom !important;
      margin-bottom: 0 !important;
    }
    .bg2 {
      background-image: url(@/assets/img/data_list_bg2.png) !important;
    }
    .bg3 {
      background-image: url(@/assets/img/data_list_bg3.png) !important;
    }
    .bg4 {
      background-image: url(@/assets/img/data_list_bg4.png) !important;
    }
  }
}
.box {
  background-color: #1b315e !important;
}
.index_link {
  height: auto !important;
  .list {
    display: flex;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .item {
    flex: 1;
    text-align: center;
    img {
      margin-bottom: 15px;
    }
  }
}

.tbox2 {
  :deep(.el-table__body-wrapper) {
    display: none;
  }
  :deep(.el-table) .cell {
    line-height: 38px;
    white-space: nowrap;
    padding: 0 5px;
  }
  .scroll_box {
    height: 385px;
    position: relative;
    overflow: hidden;
    :deep(.el-table__body-wrapper) {
      display: block;
    }
    .el-table {
      animation: infinite_scroll 10s linear infinite;
    }
  }
}
.table_empty {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    margin-bottom: 20px;
  }
  .btn {
    margin-top: 25px;
    width: 109px;
    height: 32px;
    line-height: 32px;
    background: #0058fb;
    border-radius: 2px;
    text-align: center;
  }
}

@media screen and (max-width: 1440px) {
  .box_1440_1 {
    max-width: 30%;
    flex: 0 0 30%;
    .doughnut_box {
      margin-left: 10%;
    }
  }
  .box_1440_2 {
    max-width: 30%;
    flex: 0 0 30%;
  }
  .box_1440_3 {
    max-width: 40%;
    flex: 0 0 40%;
  }
}

@media screen and (max-width: 768px) {
  .data_list .item .number {
    font-size: 16px;
  }
  .box_1440_1 {
    max-width: 100%;
    flex: 0 0 100%;
    .doughnut_box {
      margin-left: 10%;
    }
  }
  .box_1440_2 {
    max-width: 100%;
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .box_1440_3 {
    max-width: 100%;
    flex: 0 0 100%;
  }
}

.yyjy {
  :deep(.el-step.is-vertical .el-step__head) {
    top: 30px;
    .el-step__icon {
      background-color: rgb(26, 92, 255);
      border: 0;
      color: #fff;
      width: 30px;
      height: 30px;
      left: -3px;
    }
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px 10px 15px;
    border: 1px solid rgb(26, 92, 255);
    border-radius: 6px;
    margin-left: 25px;
    margin-bottom: 20px;
    color: #fff;
    font-size: 14px;
    .info {
      display: flex;
      align-items: center;
    }
    .l {
      margin-right: 10px;
    }
    .r {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      background-color: rgb(70, 201, 58);
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    a {
      color: $color;
    }
  }
}

.tools {
  .list {
    /* display: flex;
    align-items: center;
    flex-wrap: wrap; */
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .item {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      cursor: pointer;
      img {
        margin-bottom: 15px;
      }
    }
  }
}

.grid_box {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 3fr minmax(400px, 1fr);
  gap: 20px;
  .el-col {
    padding: 20px !important;
  }
}

.select_item {
  background: #1d3564;
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  padding: 10px 15px;
  cursor: pointer;
  &.active,
  &:hover {
    background-color: #194dff;
  }
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
